const BASE_URL = 'https://api.nocodebackend.com';
const INSTANCE = '41803_cinema_delivery_kanban';
const API_KEY = import.meta.env.VITE_API_KEY;

const headers = {
  'accept': '*/*',
  'Authorization': `Bearer ${API_KEY}`,
};

const transformOrder = (rawOrder) => {
  let tildaOrderId = rawOrder.tilda_order_id || `#${rawOrder.id}`;
  const transformed = {
    ...rawOrder,
    id: String(rawOrder.id || rawOrder._id),
    _id: String(rawOrder.id || rawOrder._id),
    tilda_order_id: tildaOrderId,
    name: rawOrder.name || rawOrder.customer_name || 'Без имени',
    phone: rawOrder.phone || rawOrder.customer_phone || rawOrder.email || 'Нет контакта',
    hall: rawOrder.hall || rawOrder.cinema_hall || 'N/A',
    hall_row: String(rawOrder.hall_row || rawOrder.row || '?'),
    hall_seat: String(rawOrder.hall_seat || rawOrder.seat || '?'),
    comments: rawOrder.customer_comment || rawOrder.staff_comment || rawOrder.comments || '',
    status: rawOrder.status || 'Received',
    created_at: rawOrder.created_at || rawOrder.createdAt || new Date().toISOString(),
    order: rawOrder.order || '',
  };
  return transformed;
};

const formatDateTimeForAPI = (date, isStart = true) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  if (isStart) {
    return `${year}-${month}-${day}T00:00:00.000Z`;
  } else {
    return `${year}-${month}-${day}T23:59:59.999Z`;
  }
};

// Global Mock Generator
export const generateMockOrders = (start, end, count = 20) => {
  const orders = [];
  const names = ['Alex J.', 'Sarah C.', 'Mike R.', 'Elena F.', 'John W.', 'Diana P.', 'Bruce W.', 'Tony S.', 'Natasha R.', 'Peter P.'];
  const statuses = ['Received', 'Preparing', 'Delivering', 'Completed', 'Archived'];
  const menu = [
    { name: 'Large Popcorn', price: 850 },
    { name: 'Medium Popcorn', price: 650 },
    { name: 'Small Popcorn', price: 450 },
    { name: 'Cola Zero (L)', price: 400 },
    { name: 'Sprite (M)', price: 350 },
    { name: 'Nachos Cheese', price: 700 },
    { name: 'Hot Dog', price: 550 },
    { name: 'Beer (0.5)', price: 600 },
    { name: 'Combo #3', price: 1500 },
    { name: 'VIP Champagne', price: 4500 },
  ];

  const startTime = new Date(start).getTime();
  const endTime = new Date(end).getTime();

  for (let i = 0; i < count; i++) {
    const randomTime = new Date(startTime + Math.random() * (endTime - startTime));
    const numItems = 1 + Math.floor(Math.random() * 3);
    const items = [];
    for (let j = 0; j < numItems; j++) {
      const menuItem = menu[Math.floor(Math.random() * menu.length)];
      const qty = 1 + Math.floor(Math.random() * 2);
      items.push(`${menuItem.name},${qty},${menuItem.price}`);
    }

    orders.push(transformOrder({
      id: `mock-${i}-${randomTime.getTime()}`,
      tilda_order_id: `MOCK-${10000 + i}`,
      name: names[Math.floor(Math.random() * names.length)],
      phone: '+7 999 000 00 00',
      hall: ['1', '2', '3', 'IMAX', 'VIP'][Math.floor(Math.random() * 5)],
      hall_row: String(1 + Math.floor(Math.random() * 15)),
      hall_seat: String(1 + Math.floor(Math.random() * 20)),
      created_at: randomTime.toISOString(),
      order: items.join('\n'),
      status: statuses[Math.floor(Math.random() * statuses.length)],
      comments: Math.random() > 0.7 ? 'Test order comment' : ''
    }));
  }
  return orders;
};

export const api = {
  async fetchOrders(startDate = null, endDate = null) {
    try {
      let url = `${BASE_URL}/read/orders?Instance=${INSTANCE}`;
      if (startDate) {
        const startOfDay = new Date(startDate);
        startOfDay.setHours(0, 0, 0, 0);
        const endOfDay = endDate ? new Date(endDate) : new Date(startDate);
        endOfDay.setHours(23, 59, 59, 999);

        const startDateTime = formatDateTimeForAPI(startOfDay, true);
        const endDateTime = formatDateTimeForAPI(endOfDay, false);
        url += `&created_at[gte]=${encodeURIComponent(startDateTime)}&created_at[lte]=${encodeURIComponent(endDateTime)}`;
      }

      const response = await fetch(url, { headers });
      if (!response.ok) {
        throw new Error(`Failed to fetch orders: ${response.statusText}`);
      }
      const result = await response.json();
      let rawOrders = [];
      if (Array.isArray(result)) {
        rawOrders = result;
      } else if (result.data && Array.isArray(result.data)) {
        rawOrders = result.data;
      } else if (result.orders && Array.isArray(result.orders)) {
        rawOrders = result.orders;
      }
      return rawOrders.map(transformOrder);
    } catch (error) {
      console.error('❌ API Error:', error);
      return [];
    }
  },

  async updateOrderStatus(orderId, status) {
    try {
      const url = `${BASE_URL}/update/orders/${orderId}?Instance=${INSTANCE}`;
      const response = await fetch(url, {
        method: 'PUT',
        headers: {
          ...headers,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ status }),
      });
      if (!response.ok) {
        throw new Error(`Failed to update status: ${response.statusText}`);
      }
      return await response.json();
    } catch (error) {
      console.error('❌ API Error:', error);
      throw error;
    }
  }
};